import { memo } from "react";
import { Badge } from "@/shared/components/ui/badge";
import { RentalStatus } from "@/shared/types/enums";

const STATUS_LABEL: Record<RentalStatus, string> = {
  INCOMPLETE: "Incompleto",
  COMPLETE: "Completo",
  ON_STREET: "Na rua",
  CANCELED: "Cancelado",
  FINISHED: "Finalizado",
};

const STATUS_CLASSES: Record<RentalStatus, string> = {
  INCOMPLETE: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  COMPLETE: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  ON_STREET: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  CANCELED: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  FINISHED: "bg-violet-500/15 text-violet-300 border-violet-500/30",
};

interface RentalStatusBadgeProps {
  status: RentalStatus;
  expectedInAt?: string;
}

export const RentalStatusBadge = memo(function RentalStatusBadge({
  status,
  expectedInAt,
}: RentalStatusBadgeProps) {
  let label = STATUS_LABEL[status];
  let className = STATUS_CLASSES[status];

  if (
    status === RentalStatus.ON_STREET &&
    expectedInAt &&
    new Date(expectedInAt) < new Date()
  ) {
    label = "Atrasado";
    className = "bg-red-500/15 text-red-400 border-red-500/30";
  }

  return (
    <Badge variant="outline" className={className}>
      {label}
    </Badge>
  );
});

export const RENTAL_STATUS_LABELS = STATUS_LABEL;
